import React from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';

import routes from 'app/routes';

import {
  Button,
} from 'react-bootstrap5';

import Actions from 'components/Members/Schedule/Actions';

export default function SessionButton({ step, programId }) {
  const possibleReschedule = step.actions.some(
    (action) => action.action === 'reschedule' || action.action === 'cancel',
  );
  const sessionPresent = step.session;

  const navigate = useNavigate();

  let name = 'Schedule';
  let isScheduling = true;
  if (possibleReschedule) {
    name = 'Reschedule';
    isScheduling = false;
  } else if (sessionPresent) {
    name = 'Session';
    isScheduling = false;
  }

  const onScheduleClick = () => {
    Actions.possibilitySchedule(step.program_id, (data) => {
      if (data.possibility) {
        navigate(routes.members.steps.schedule(step.id), {
          state: { source: 'program', sourceId: programId },
        });
      } else {
        navigate(routes.members.programs.program.step.buyOrSkip(step.id), {
          state: { isPossibleSkip: data.isPossibleSkip, reason: data.reason },
          preventScrollReset: true,
        });
      }
    });
  };

  return (
    <>
      {isScheduling && (
      <Button
        variant="light"
        className="btn-reverse ms-lg-3 mb-3 mb-lg-0 step-action-btn"
        onClick={onScheduleClick}
      >
        {name}
      </Button>
      )}
      {!isScheduling && (
      <Link
        to={routes.members.steps.schedule(step.id)}
        state={{ source: 'program', sourceId: programId }}
        className="btn btn-light btn-reverse ms-lg-3 mb-3 mb-lg-0 step-action-btn"
      >
        {name}
      </Link>
      )}
    </>
  );
}

SessionButton.propTypes = {
  step: PropTypes.object.isRequired,
  programId: PropTypes.number.isRequired,
};
